(() => {
  'use strict';

  const expectedShop = 'kkv2jg-kq.myshopify.com';
  const expectedPrefix = expectedShop.split('.', 1)[0].replace(/[^a-z0-9]/g, '').slice(0, 8);
  const html = document.documentElement;
  let locked = false;

  const isPreview = () => html.dataset.ovaPreview === 'true'
    || window.Shopify?.designMode === true
    || window.Shopify?.visualPreviewMode === true;

  const isValid = () => {
    const marker = document.querySelector('[data-scale-license-proof]');
    if (!marker) return false;

    const expiresAt = Date.parse(marker.dataset.scaleLicenseExpiresAt || '');
    const primary = marker.dataset.scaleLicensePrimary || '';
    const secondary = marker.dataset.scaleLicenseSecondary || '';
    const integrity = marker.dataset.scaleLicenseIntegrity || '';
    const primaryPrefix = `${expectedShop}::`;
    const secondaryPrefix = `${expectedShop}|`;
    const integrityPrefix = `${expectedPrefix}_`;
    const isDigest = (value, prefix) => value.startsWith(prefix)
      && /^[a-f0-9]{64}$/.test(value.slice(prefix.length));

    return marker.dataset.scaleLicenseShop === expectedShop
      && isDigest(primary, primaryPrefix)
      && isDigest(secondary, secondaryPrefix)
      && isDigest(integrity, integrityPrefix)
      && marker.dataset.scaleLicenseStatus === 'active'
      && Number.isFinite(expiresAt)
      && expiresAt > Date.now();
  };

  const lock = () => {
    if (locked || isPreview()) return;
    locked = true;
    document.title = 'Licence Scale Ova inactive';
    document.body.innerHTML = '<main style="position:fixed;inset:0;z-index:2147483647;display:grid;place-items:center;padding:24px;background:#0b0b0c;color:#fff;font:16px/1.5 system-ui,-apple-system,sans-serif;text-align:center"><div style="max-width:520px"><h1 style="margin:0 0 12px;font-size:30px">Licence Scale Ova inactive</h1><p style="margin:0;color:#b8b8bd">Le propriétaire de cette boutique doit réactiver sa licence depuis Scale Ova.</p></div></main>';
  };

  const verify = () => {
    if (!isPreview() && !isValid()) lock();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', verify, { once: true });
  } else {
    verify();
  }
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) verify();
  });
  window.setInterval(verify, 30000);
})();